<full-calendar *ngIf="projectID; else loading" #calendar [options]="calendarOptions()"> </full-calendar>

<ng-template #loading>
  <div class="flex justify-center items-center">
    <p-progressSpinner ariaLabel="loading" />
  </div>
</ng-template>
